import React from 'react';
import Dashboard from 'components/Layout/Dashboard/Dashboard';
import AccountSettings from 'components/UserSettings/AccountSettings';
import { compose } from 'redux-starter-kit';
import { connect } from 'react-redux';
import selectors from 'store/selectors';

const UserSettings = ({ advisor }: any) => {
  return (
    <Dashboard>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '32px',
          marginTop: '32px'
        }}
      >
        <AccountSettings advisor={advisor} />
      </div>
    </Dashboard>
  );
};

export default compose(
  connect(
    (state: any) => ({
      advisor: selectors.advisorSelectors.getAdvisor(state)
    }),
    null
  )
)(UserSettings);
